import { render, staticRenderFns } from "./petList.vue?vue&type=template&id=15a6abec&scoped=true&"
import script from "./petList.vue?vue&type=script&lang=js&"
export * from "./petList.vue?vue&type=script&lang=js&"
import style0 from "./petList.vue?vue&type=style&index=0&id=15a6abec&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a6abec",
  null
  
)

export default component.exports